module.exports = __webpack_public_path__ + "img/Indonesia.e40d43d0.jpg";